// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "ca4cf6954ba0777d4bd4" + ".chunk.js";
};